import { Injectable } from "@angular/core";
import { SIGNALR_CONFIG } from "./signalR.utils";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { HttpClient } from '../services/http-client';
import './jquery.signalR-2.2.3.min.js';
import {NegocioViewModel} from '@utils/ViewModels';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class SignalrService {
    public onInitialized(result: boolean): void { }
    public onConnected(connection: any): void { }
    public Connection: any;
    public SignalR: any;
    public isInitialized = new ReplaySubject<boolean>();
    private priceMessage = new Subject();
    private negocioMessage = new Subject<NegocioViewModel>();
    private editedNegocioMessage = new BehaviorSubject(null);

    newPrice = this.priceMessage.asObservable();
    newNegocioMessage = this.negocioMessage.asObservable();
    newEditedNegocioMessage = this.editedNegocioMessage.asObservable();

    constructor(private httpClient: HttpClient){

    }

    public initializeService(useDefaultFunctions: boolean = true) {
        let self = this;
        let jq: any = $;
        let scriptNode = document.createElement('script');
        scriptNode.type = 'text/javascript';
        scriptNode.src = SIGNALR_CONFIG.URLS.HUBS;

        // Callback para cuando se cargue este script externo
        scriptNode.onload = function () {
            self.SignalR = jq;
            jq.connection.hub.url = SIGNALR_CONFIG.URLS.API;
            self.Connection = jq.connection;
            setTimeout(() => {
                self.onInitialized(true);
                self.isInitialized.next(true);
            }, 1);
        }
        scriptNode.onerror = function (error: any) {
            console.error(error);
            self.onInitialized(false);
        }

        if (useDefaultFunctions) {
            this.setDefaultCallbackFunctions();
        }

        // Forma alternativa a incluir un script externo en lugar de incluir un tag <script> en el <head> de index.html
        document.getElementsByTagName('head')[0].appendChild(scriptNode);
    }

    setDefaultCallbackFunctions() {
        this.onInitialized = e => {
          if (e) {
            this.setSignalrEvents();
            this.setDisconnectedCallback();
            //this.startConnection();
          }
        };

        this.onConnected = connection => {
          let hub = connection[SIGNALR_CONFIG.HUBS.NOTIFICATION];
          let token = localStorage.getItem('token');
          let userId = localStorage.getItem('userId');
          let acopiosNetwork = localStorage.getItem('acopiosNetwork').split(',');
          hub.invoke('AllowUser', userId, token, acopiosNetwork, true);
        };
    }

    startConnection(): any {
        if (this.isConnected()) {
            return;
        }

        let hub = this.Connection[SIGNALR_CONFIG.HUBS.NOTIFICATION];

        this.Connection.hub.start({ transport: 'longPolling' }).done(() => this.onConnected(this.Connection));
        hub.client.priceChange = precios => {
          this.priceMessage.next(precios);
        };

        hub.client.newNegocioMessage = negocio => {
          this.negocioMessage.next(negocio);
        };

        hub.client.newEditedNegocioMessage = edited => {
          this.editedNegocioMessage.next(edited);
        };
        //setTimeout(_=>this.Connection.hub.stop(), 2000);
    }

    addEvents(hubName: string, eventName: string, event: any, currentDoc: any): any {
        let hub = this.Connection[hubName];
        hub.client[eventName] = (e) => {
            event(currentDoc, e);
        }
    }

    isConnected(): boolean {
      return this.Connection.hub && this.Connection.hub.state !== this.Connection.connectionState.disconnected;
    }

    priceChange(self: any, prices: any){
      self.priceMessage.next(prices);
    }

    newNegocio(self: any, negocio: any){
      self.negocioMessage.next(negocio);
    }

    editedNegocio(self: any){
      self.editedNegocioMessage.next();
    }

    setSignalrEvents() {
      this.addEvents(SIGNALR_CONFIG.HUBS.NOTIFICATION, SIGNALR_CONFIG.SERVEREVENTS.PRICECHANGE, this.priceChange, this);
      this.addEvents(SIGNALR_CONFIG.HUBS.NOTIFICATION, SIGNALR_CONFIG.SERVEREVENTS.NEWNEGOCIO, this.newNegocio, this);
      this.addEvents(SIGNALR_CONFIG.HUBS.NOTIFICATION, SIGNALR_CONFIG.SERVEREVENTS.EDITED_NEGOCIO, this.editedNegocio, this);
    }

    setDisconnectedCallback() {
        this.Connection.hub.disconnected(_ => {
          console.log(this);

          // Si la conexión de signalr se cayó, y aun estamos logueados a Unco reconectamos...
          if (localStorage.getItem('username') && this.Connection.hub.state === this.Connection.connectionState.disconnected) {
            this.Connection.hub.start({ transport: 'longPolling' }).done(() => {
                this.onConnected(this.Connection);
                const connectionId = this.Connection.hub.id;
                const isWeb = true;
                this.httpClient.post('/api/user/update-signalr-id/${connectionId}/${isWeb}', null)
                  .map((response: Response) => {
                    return response.json();
                  });
            });
          }
        });
    }

    disconnect() {
        if (this.Connection && this.Connection.hub) {
            this.Connection.hub.stop();
        }
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/signalr/signalR.service.ts